import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { Trans, useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        NotOperationModal: {};
    }
}

const NotOperationModal: ActivityComponentType<'NotOperationModal'> = () => {
    const { t } = useTranslation('main');
    const { replace } = useFlow();
    return (
        <AppModal deny={t('notOperationModal.cancel')}
            confirm={t('notOperationModal.confirm')}
            onConfirm={() => replace('ShopListActivity', { type: 'LIST', isOrder: true })} >
            <Text size='title' align='center'>
                <Trans ns='main' i18nKey='notOperationModal.message' components={{ br: <br/> }} />
            </Text>
        </AppModal>
    );
};

export default NotOperationModal;
